export default {"src":"/_next/static/media/businessPreventLawsuits.da739940.svg","height":30,"width":35,"blurWidth":0,"blurHeight":0};